<fieldset *ngIf="initialized()" class="c-target-audience-selector__age" [formGroup]="form">
	@if (!form.get('noAgeLimit').value) {
		<fieldset class="c-target-audience-selector__age__range">
			<cjm-input-wrapper
				inputId="minAge"
				[label]="i18nKeys.SharedAssociations.Forms.TargetAudience.AgeField.MinAge.Label | translate"
			>
				<input
					#input
					type="number"
					formControlName="minAge"
					cypressTag="TargetAudienceSelector.Input.MinAge"
					[min]="associationTargetAudience.MIN_AGE"
					[max]="
						withFullRange ? associationTargetAudience.DEFAULT_MAX_AGE : associationTargetAudience.MAX_AGE
					"
					[placeholder]="
						i18nKeys.SharedAssociations.Forms.TargetAudience.AgeField.MinAge.Placeholder | translate
					"
				/>
			</cjm-input-wrapper>
			<div class="c-target-audience-selector__age__range__divider">–</div>
			<cjm-input-wrapper
				inputId="maxAge"
				[label]="i18nKeys.SharedAssociations.Forms.TargetAudience.AgeField.MaxAge.Label | translate"
			>
				<input
					#input
					type="number"
					formControlName="maxAge"
					cypressTag="TargetAudienceSelector.Input.MaxAge"
					[min]="associationTargetAudience.MIN_AGE"
					[max]="
						withFullRange ? associationTargetAudience.DEFAULT_MAX_AGE : associationTargetAudience.MAX_AGE
					"
					[placeholder]="
						i18nKeys.SharedAssociations.Forms.TargetAudience.AgeField.MaxAge.Placeholder | translate
					"
				/>
			</cjm-input-wrapper>
		</fieldset>

		@if (withSlider) {
			<fieldset class="c-target-audience-selector__age__range-slider">
				<mat-slider
					class="c-target-audience-selector__age__range-slider__slider"
					discrete
					[min]="associationTargetAudience.MIN_AGE"
					[max]="associationTargetAudience.MAX_AGE"
				>
					<input
						matSliderStartThumb
						cypressTag="TargetAudienceSelector.Slider.MinAge"
						[value]="form.get('minAge').value"
						(dragEnd)="minValueSliderChange($event)"
					/>
					<input
						matSliderEndThumb
						cypressTag="TargetAudienceSelector.Slider.MaxAge"
						[value]="form.get('maxAge').value"
						(dragEnd)="maxValueSliderChange($event)"
					/>
				</mat-slider>
			</fieldset>
		}

		<div class="c-input__description is-error u-margin-bottom">
			<ng-container ngxErrors="minAge">
				<div ngxError="min" showWhen="dirty">
					{{
						i18nKeys.FormLabels.InputMinValue
							| translate
								: {
										inputLabel:
											i18nKeys.SharedAssociations.Forms.TargetAudience.AgeField.Titles.Age
											| translate,
										value: associationTargetAudience.MIN_AGE
								  }
					}}
				</div>
			</ng-container>
			<ng-container ngxErrors="minAge">
				<div ngxError="max" showWhen="dirty">
					{{
						i18nKeys.FormLabels.InputMaxValue
							| translate
								: {
										inputLabel:
											i18nKeys.SharedAssociations.Forms.TargetAudience.AgeField.Titles.Age
											| translate,
										value: associationTargetAudience.MAX_AGE
								  }
					}}
				</div>
			</ng-container>
			<ng-container ngxErrors="maxAge">
				<div ngxError="min" showWhen="dirty">
					{{
						i18nKeys.FormLabels.InputMinValue
							| translate
								: {
										inputLabel:
											i18nKeys.SharedAssociations.Forms.TargetAudience.AgeField.Titles.Age
											| translate,
										value: associationTargetAudience.MIN_AGE
								  }
					}}
				</div>
			</ng-container>
			<ng-container ngxErrors="maxAge">
				<div ngxError="max" showWhen="dirty">
					{{
						i18nKeys.FormLabels.InputMaxValue
							| translate
								: {
										inputLabel:
											i18nKeys.SharedAssociations.Forms.TargetAudience.AgeField.Titles.Age
											| translate,
										value: withFullRange
											? associationTargetAudience.DEFAULT_MAX_AGE
											: associationTargetAudience.MAX_AGE
								  }
					}}
				</div>
			</ng-container>
			@if (form.getError('compareError')) {
				<div>
					{{ i18nKeys.SharedAssociations.Forms.TargetAudience.AgeField.Titles.ErrorMessage | translate }}
				</div>
			}
		</div>
	}

	@if (withAllAgesCheckbox) {
		<cjm-checkbox
			formControlName="noAgeLimit"
			cypressTag="TargetAudienceSelector.Input.AllAges"
			[id]="'noAgeLimit'"
			[title]="i18nKeys.SharedAssociations.Forms.TargetAudience.AgeField.Label | translate"
			[label]="i18nKeys.SharedAssociations.Forms.TargetAudience.AgeField.Label | translate"
			>{{ i18nKeys.SharedAssociations.Forms.TargetAudience.AgeField.Label | translate }}
		</cjm-checkbox>
	}
</fieldset>
